import { EmailSchedulesContext } from "@components/preferences";
import BackButton from "@components/back_button.tsx";
import Container from "@components/ui/container.tsx";
import { EmailSchedule } from "@components/job_alerts/types.ts";
import { JobAlertsHeader, SubscriptionCountProvider } from "@components/job_alerts/header.tsx";
import { ErrorBoundary } from "react-error-boundary";
import { ErrorState } from "@components/job_alerts/error_state.tsx";
import { LoadingState } from "@components/job_alerts/loading_state.tsx";
import { Suspense } from "react";
import { JobAlertsGrid } from "@components/job_alerts/grid.tsx";

type Props = {
  paths: {
    notificationSchedulePath: string;
  };
  emailSchedule: EmailSchedule;
  emailSchedules: { [key: string]: number };
};

const JobAlertsPage = ({ paths, emailSchedule, emailSchedules }: Props) => {
  return (
    <Container className="!max-w-[1550px]">
      <EmailSchedulesContext.Provider
        value={{
          emailSchedule,
          emailSchedules,
          notificationSchedulePath: paths.notificationSchedulePath,
        }}
      >
        <ErrorBoundary fallback={<ErrorState />}>
          <Suspense fallback={<LoadingState />}>
            <SubscriptionCountProvider>
              <BackButton />
              <JobAlertsHeader />
              <JobAlertsGrid />
            </SubscriptionCountProvider>
          </Suspense>
        </ErrorBoundary>
      </EmailSchedulesContext.Provider>
    </Container>
  );
};

export default JobAlertsPage;
